import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as admin from '../../../admin'
import * as relay from '../../../relay'
import type { Feature } from '../feature'
import * as gql from '../gql'

/**
 * Executes a Quiver deployment request
 */
export const executeDeploy = store.effects.create(
  (feature: Feature, contextsFeature: admin.contexts.Feature) =>
    feature.actions.deploy.request.observe().pipe(
      rxjsUtils.latestFrom(request => ({
        evaluation: feature.selectors.currentEvaluation.asObservable,
        request: rxjs.of(request),
        zoneContext: contextsFeature.selectors.zoneContext.asObservable,
      })),
      rxjs.switchMap(({ request, evaluation, zoneContext }) => {
        // Validating parameters
        if (!zoneContext) {
          return rxjs.of(
            feature.actions.deploy.cancellation.from(request).create({
              reason: 'Cannot proceed without a current tenant & zone',
              request: request.data,
            }),
          )
        }
        const commands = evaluation?.commands
        if (!commands?.length) {
          return rxjs.of(
            feature.actions.deploy.cancellation.from(request).create({
              reason: 'Quiver evaluation is not yet ready for deployment',
              request: request.data,
            }),
          )
        }
        // Executing
        return gql.queries.deploy
          .execute({
            ...zoneContext,
            commands:
              relay.commands.gql.inputs.command.LIST_TRANSFORMER.getGqlFrom(
                commands,
              ),
          })
          .pipe(
            // Processing response
            rxjs.map(() =>
              feature.actions.deploy.success.from(request).create({
                request: request.data,
              }),
            ),
            // Handling error
            rxjs.catchError((error: Error) =>
              rxjs.of(
                feature.actions.deploy.error.from(request).create({
                  error,
                  request: request.data,
                }),
              ),
            ),
          )
      }),
    ),
)
